<template lang="pug">
  div.flex-container.align-center(v-if="showPaginator")
    ods-button(type="text" icon="ods-icon-chevron-left" @click.prevent="buttonPrevAction" :disabled="buttonPrevVisibility")
    span.current-page {{ page }}
    ods-button(type="text" icon="ods-icon-chevron-right" @click.prevent="buttonNextAction" :disabled="buttonNextVisibility")
</template>

<script>
export default {
  name: 'Paginator',

  props: {
    isNextPage: {
      type: String
    },
    currentPage: {
      default: 1
    }
  },

  computed: {
    onlyOnePage () {
      return this.currentPage === ''
    },
    page () {
      return this.onlyOnePage ? 1 : this.currentPage
    },
    showPaginator () {
      // Descomentar si se quiere ocultar el paginador cuando solo tenga una página
      // return !this.onlyOnePage
      return true
    },
    buttonPrevVisibility () {
      return this.currentPage === 1 || this.onlyOnePage
    },
    buttonNextVisibility () {
      if (this.isNextPage === 'S') {
        return false
      } else if (this.isNextPage === 'N') {
        return true
      } else {
        return true
      }
    }
  },

  methods: {
    buttonPrevAction () {
      this.$emit('buttonPrevAction')
    },
    buttonNextAction () {
      this.$emit('buttonNextAction')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ods-button {
  &--text {
    padding: 0 !important;
    margin: rem(8);
  }
}
.current-page {
  background: $--color-primary;
  color: $--color-white;
  text-align: center;
  width: rem(24);
  height: rem(24);
}
</style>
